import _return from "./return";
import acknowledgement from "./acknowledgement"
import address from "./address";
import approval from "./approval"
import auth from "./auth";
import catalog from "./catalog"
import errors from "./errors";
import helpdesk from "./helpdesk"
import home from "./home";
import impersonation from "./impersonation"
import order from "./order";
import privacy from "./privacy"
import products from "./products"
import quiz from "./quiz";
import survey from "./survey";
import surveys from "./surveys";
import terms from "./terms"
import tunnel from "./tunnel";

export default {
    acknowledgement,
    address,
    approval,
    auth,
    catalog,
    errors,
    helpdesk,
    home,
    impersonation,
    order,
    privacy,
    products,
    quiz,
    return: _return,
    survey,
    surveys,
    terms,
    tunnel,

    maintenance: {
        header: "Wir werden bald zurück sein!",
        message: "Es tut uns sehr leid für die Unannehmlichkeiten, aber wir führen Wartungsarbeiten durch.<br/> Bitte schaue bald wieder vorbei..."
    }
}